import NarratorScholars from './NarratorScholars';

export { NarratorScholars };
